"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AsyncDeleteBlogModalContainer;

var _react = _interopRequireDefault(require("react"));

var _Loadable = _interopRequireDefault(require("UIComponents/decorators/Loadable"));

var DeleteBlogModalContainer = (0, _Loadable.default)({
  loader: function loader() {
    return import('./DeleteBlogModalContainer'
    /* webpackChunkName: "chunk-website-blog" */
    );
  },
  LoadingComponent: function LoadingComponent() {
    return null;
  }
});

function AsyncDeleteBlogModalContainer(props) {
  return _react.default.createElement(DeleteBlogModalContainer, props);
}

module.exports = exports.default;